<!--  -->
<template>
  <div>
    <div class="mountains">
      <svg class="mountain" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 24 150 28" preserveAspectRatio="none" shape-rendering="auto">
        <defs>
          <path id="gentle-wave" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z" />
        </defs>
        <g class="parallax">
          <use xlink:href="#gentle-wave" x="48" y="0" fill="rgba(34, 34 ,34, .1)" />
          <use xlink:href="#gentle-wave" x="48" y="3" fill="rgba(34, 34 ,34, .5)" />
          <use xlink:href="#gentle-wave" x="48" y="5" fill="rgba(34, 34 ,34, .5)" />
          <use xlink:href="#gentle-wave" x="48" y="7" fill="#333" />
        </g>
      </svg>
    </div>

    <div class="FooterBar">
    <div class="innerbox">
      <div>
        <div class="logo-qrcode">
          <img src="https://oss.sbooip.com/static/www/pc/assets/images/sboobotemo.png" alt="" class="logo">
        </div>
        <div class="number">
          <div class="diqu">专利机构代码：44506</div>
          <div>深圳胜博时代专利代理事务所（普通合伙）</div>
        </div>
        <div class="company">
          <div class="diqu">深圳总部：</div>
          <div>{{ Company.addr_1 }}</div>
          <div class="diqu">龙华分公司：</div>
          <div>{{ Company.addr_2 }}</div>
          <div>{{ Company.phone }} </div>
        </div>
      </div>
      <div class="categorybox">
        <div class="category">
          <div class="categoryitem" v-for="(item, index) in subItems">
            <div class="navtitle">{{ item.title }}</div>
            <template v-for="sub in item.sub">
              <router-link :to="sub.path" active-class="active">
                <div class="subitem">{{ sub.name }}</div>
              </router-link>
            </template>
          </div>
        </div>
      </div>
    </div>

    <div class="banquan">
      <div class="qrcodbox">
        <img class="qrcode" src="https://oss.sbooip.com/static/www/pc/assets/images/gonghao.png" alt="">
        <div class="guanzu">微信公众号</div>
      </div>

      <span> {{ Company.copyright }}</span>
      <span class="beian">{{ Company.company }}</span>
      <a href="https://beian.miit.gov.cn/">备案/许可证编号：粤ICP备2023101493号</a>
      <img src="https://oss.sbooip.com/static/www/pc/assets/images/govIcon.gif" alt="" class="govIcon">
      <img src="" alt="">
    </div>
  </div>
  </div>
  
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  name: "FooterBar",
  data() {
    return {
      width: document.documentElement.clientWidth,
      subItems: [
        {
          title: '关于我们',
          sub: [
            { name: '公司简介', path: '/About/Company' },
            { name: '发展历程', path: '/About/History' },
            { name: '荣誉资质', path: '/About/Qualification' },
            { name: '团队风采', path: '/About/TeamSpirit' },
            { name: '合作客户', path: '/About/CooperativeClients' },
            { name: '案例展示', path: '/About/CaseShowcase' },
            { name: '人才招聘', path: '/About/TalentRecruitment' }
          ]
        },
        {
          title: '商标注册',
          sub: [
            { name: '查询与设计', path: '/Trademark/SearchDesign' },
            { name: '续展与变更', path: '/Trademark/Renewal' },
            { name: '异议与撤三', path: '/Trademark/NonCancellation' },
            { name: '答辩与复审', path: '/Trademark/AnswerReview' },
            { name: '监测与维权', path: '/Trademark/Surveillance' }
          ]
        },
        {
          title: '专利申请',
          sub: [
            { name: '检索与撰写', path: '/Patent/SearchWrite' },
            { name: '无效与答辩', path: '/Patent/InvalidationResponse' },
            { name: '转让与许可', path: '/Patent/TransferLicense' },
            { name: '优审与快审', path: '/Patent/FastTrackExamination' },
            { name: '布局与规划', path: '/Patent/Planning' }
          ]
        },
        {
          title: '版权登记',
          sub: [
            { name: '作品登记', path: '/Copyright/Registration' },
            { name: '作品维权', path: '/Copyright/RightsProtection' }
          ]
        },
        {
          title: '知产维权',
          sub: [
            { name: '发明专利维权', path: '/knowledge/InventionPatent' },
            { name: '实用新型专利维权', path: '/knowledge/UtilityPatent' },
            { name: '外观设计专利维权', path: '/knowledge/DesignPatent' },
            { name: '商品商标维权', path: '/knowledge/GoodsTrademark' },
            { name: '服务商标维权', path: '/knowledge/ServiceMark' },
            { name: '著作权维权', path: '/knowledge/CopyrightRights' }
          ]
        },
        {
          title: '动态资讯',
          sub: [
              { name: '全部', path: '/IndustryNews/AllNews' },
              { name: '行业新闻', path: '/IndustryNews/SectorNews' },
              { name: '公司动态', path: '/IndustryNews/CompanyNews' },
              { name: '知识分享', path: '/IndustryNews/KnowledgeSharing' }
          ]
        }
      ]
    }
  },
  created(){

  },
  computed: {
    // 获取store中的数据,mapStates数组写法
    ...mapState('home', ['activeRoute','Company']),
  },
  watch: {
    $route: {
      handler(to) {
        // 方法在mixin模块
        this.updateActiveRoute(to.name)
      }
    }
  },
  methods: {
    //方式二：借助mapMutations 调用commit
    ...mapMutations('home', ['SETACTIVE']),
  }
}
</script>
<style lang='scss' scoped>
a {
  color: #b4b4b4;
  text-decoration: none;
  font-size: 14px;
}

.FooterBar {
  overflow: hidden;
  padding: 80px 80px 40px 80px;
  background-color: #333;
  font-size: 14px;
  box-sizing: border-box;
  position: relative;
}

.scollbar {
  position: absolute;
  top: 14px;
  width: 1226px;
  left: 50%;
  transform: translateX(-50%);
}

.innerbox {
  width: 1226px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  padding-bottom: 20px;
  border-bottom: 1px solid #555454;
  box-sizing: border-box;
}

.number {
  color: #b4b4b4;
  margin-top: 20px;
  .diqu {
    margin-bottom: 10px;
  }
}

.logo {
  width: 200px;
}

.company {

  div {
    color: #b4b4b4;
    margin-bottom: 20px;
  }

  .diqu {
    margin-bottom: 10px;
  }

  margin-top: 20px;
}

.logo-qrcode {
  // background-color: aqua;
  display: flex;
  align-items: flex-start;
}



.navtitle {
  margin-bottom: 40px;
  color: #9e9c9c;
}

.categorybox {
  display: flex;
  justify-content: center;
}

.category {
  display: flex;
  color: white;
}

.categoryitem {
  margin: 0 40px;
}

.subitem {
  margin-bottom: 20px;
}

.active {
  color: white !important;
  font-weight: bold;
}

.banquan {
  margin-top: 20px;
  color: #b4b4b4;
  padding-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.beian {
  margin: 0 20px;
}

.govIcon {
  height: 30px;
  margin-left: 10px;
}

.qrcodbox {
  margin-right: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.qrcode {
  border-radius: 4px;
  width: 70px;
  opacity: 0.7;
}

.guanzu {
  text-align: center;
  font-size: 12px;
  margin-top: 8px;
}

.parallax>use {
  animation: move-forever 25s cubic-bezier(.55, .5, .45, .5) infinite;
}

.parallax>use:nth-child(2) {
  animation-delay: -3s;
  animation-duration: 10s;
}

@keyframes move-forever {
  0% {
    transform: translate3d(-90px, 0, 0);
  }

  100% {
    transform: translate3d(85px, 0, 0);
  }
}
svg:not(:root) {
    overflow: hidden;
}
.mountains{
  width: 100%;
  background-color: #ebe9e9;
}
.mountain {
    position: relative;
    width: 100%;
    height: 15vh;
    margin-bottom: -7px;
    min-height: 100px;
    max-height: 150px;
    background: none;
}
</style>